export default __webpack_public_path__ + "static/media/gnl3.91738bdf.webp";